<template>
  <div id="app">
    <router-view />
    <GlobalAlert />
  </div>
</template>

<script>
import GlobalAlert from '@/components/GlobalAlert.vue'

export default {
  name: 'App',
  components: {
    GlobalAlert
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background-color: #ffffff;
  min-height: 100vh;
}

#app {
  min-height: 100vh;
}
</style>